/**
 *  Filename ....: dw-dropdown.component.ts
 *  Created by ..: ianday
 *  on Date .....: 11/8/23
 **/
import { Component, EventEmitter, Input, OnInit, Output, DoCheck  } from '@angular/core';

export class dataRecord {
	public id: string;
	public description: string;
	constructor(idVal: string, desc: string) {
		this.id = idVal;
		this.description = desc;
	}
}

@Component({
	selector: 'dw-dropdown',
	templateUrl: './dw-dropdown.component.html',
	styleUrls: ['./dw-dropdown.component.css']
})

export class DwDropdownComponent implements OnInit, DoCheck {

	public _id: string;
	public _disabled: boolean = false;
	public _dataSource: any = [];
	public _selectedItem: any;
	public Idx:  number = -1;
	public _controlWidth: string | null = '120px';
	public _fontSize: string | null = '10pt';
	public activeInactiveList: Array<dataRecord>;
	public placeholder: string = "-Please Select-"
	searchText: string = '';
	filteredData: any[] = [];
	@Input() enableSearch: boolean = false;


	@Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

	@Input() set id(value: string) {
		this._id = value;
	}
	get id(): string {
		return this._id;
	}
	@Input() set disabled(value: boolean) {
		this._disabled = value;
	}
	get disabled(): boolean {
		return this._disabled;
	}

	@Input() multiSelect: boolean = false;

	@Input() set useStatusOptions(val: string) {
		this.activeInactiveList = new Array<dataRecord>();

		if (val === undefined) {
			throw  (new Error('Must have a value with this option'));
			return;
		}
		if (val === 'all') {
			this.activeInactiveList.push(new dataRecord('All', 'All'));
			this.activeInactiveList.push(new dataRecord('Active', 'Active'));
			this.activeInactiveList.push(new dataRecord('InActive', 'InActive'));
		}
		else if (val === 'status') {
			this.activeInactiveList.push(new dataRecord('Active', 'Active'));
			this.activeInactiveList.push(new dataRecord('InActive', 'InActive'));
		}
		else if (val === 'statusdeletedall') {
			this.activeInactiveList.push(new dataRecord('All', 'All'));
			this.activeInactiveList.push(new dataRecord('Active', 'Active'));
			this.activeInactiveList.push(new dataRecord('InActive', 'InActive'));
			this.activeInactiveList.push(new dataRecord('Deleted', 'Deleted'));
		}
		else if (val === 'statusdiscontinuedall') {
			this.activeInactiveList.push(new dataRecord('All', 'All'));
			this.activeInactiveList.push(new dataRecord('Active', 'Active'));
			this.activeInactiveList.push(new dataRecord('InActive', 'InActive'));
			this.activeInactiveList.push(new dataRecord('Discontinued', 'Discontinued'));
		}
		else if (val === 'statusdiscontinued') {
			this.activeInactiveList.push(new dataRecord('Active', 'Active'));
			this.activeInactiveList.push(new dataRecord('InActive', 'InActive'));
			this.activeInactiveList.push(new dataRecord('Discontinued', 'Discontinued'));
		}
		else if (val === 'yesno') {
			this.placeholder = '--';
			this.activeInactiveList.push(new dataRecord('--', '--'));
			this.activeInactiveList.push(new dataRecord('Yes', 'Yes'));
			this.activeInactiveList.push(new dataRecord('No', 'No'));
		}
		else if (val === 'yesnoonly') {
			this.activeInactiveList.push(new dataRecord('Yes', 'Yes'));
			this.activeInactiveList.push(new dataRecord('No', 'No'));
		}
		else if (val === 'ynd') {
			this.activeInactiveList.push(new dataRecord('Yes', 'Yes'));
			this.activeInactiveList.push(new dataRecord('No', 'No'));
			this.activeInactiveList.push(new dataRecord('Does Not Apply', 'Does Not Apply'));
		}
		else if (val === 'controlType') {
			this.activeInactiveList.push(new dataRecord('YND', 'Yes / No / Does Not Apply'));
			this.activeInactiveList.push(new dataRecord('Text', 'Text'));
			this.activeInactiveList.push(new dataRecord('Number', 'Number'));
			this.activeInactiveList.push(new dataRecord('Date', 'Date'));
		}
		else if (val === 'genderItems') {
			this.activeInactiveList.push(new dataRecord('Unknown', 'Unknown'));
			this.activeInactiveList.push(new dataRecord('Male', 'Male'));
			this.activeInactiveList.push(new dataRecord('Female', 'Female'));
			this.activeInactiveList.push(new dataRecord('Other', 'Other'));
		}
		else if (val === 'andor') {
			this.activeInactiveList.push(new dataRecord('AND', 'AND'));
			this.activeInactiveList.push(new dataRecord('OR', 'OR'));
		}

		this.dataSource = this.activeInactiveList;
	}

	@Input() set dataSource(val: any) {
		this._dataSource = val;
	}
	get dataSource(): any {
		return this._dataSource;
	}
	@Input() set selectedItem(value: any) {
		this._selectedItem = value;

	}
	get selectedItem(): any {
		return this._selectedItem;
	}
	@Input() set controlWidth(value: any) {
		this._controlWidth = value;
	}
	get controlWidth(): any {
		return this._controlWidth;
	}

	@Input() set fontSize(value: any) {
		this._fontSize = value;
	}
	get fontSize(): any {
		return this._fontSize;
	}

	constructor() {
	}

	ngOnInit() {
	}
	public onDropDownKeyDown(event: any): void {
		const len: number = this.dataSource.length;

		if ((this.dataSource !== undefined) && (this.dataSource.length > 0)) {
			this.Idx = this.dataSource.findIndex(s => s.id === this.selectedItem);
		}
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedItem = this.dataSource[++this.Idx].id;
			}
		}
		else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedItem = this.dataSource[--this.Idx].id;
			}
		}
		else if (event.key === 'Enter') {
			this.selectedItem = this.dataSource[this.Idx].id;
		}
	}

	public onDwItemSelected(ev: any): void {
		this.selectedItem = ev.value;
		this.itemSelected.emit(ev.value);
	}
	
	onOpenChange(open: boolean) {
		if (open && this.enableSearch) {
			this.filteredData = this._dataSource;
			this.searchText = '';
		}
	}
	
	ngDoCheck() {
		if (!this.enableSearch) {
			this.filteredData = this._dataSource;
			return;
		}

		if (this.searchText) {
			const s = this.searchText.toLowerCase();
			this.filteredData = this._dataSource.filter(x =>
				(x.description || '').toLowerCase().includes(s)
			);
		} else {
			this.filteredData = this._dataSource;
		}
	}
}


